import React from 'react';

import { FormLabel, Stack, TextField } from '@mui/material';

interface Props {
  error?: boolean;
  helperText?: string;
  label: string;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
}

export default function PackageTextField({ error, helperText, label, required, value, onChange }: Props) {
  return (
    <Stack spacing={1}>
      <FormLabel required={required}>{label}</FormLabel>
      <TextField
        value={value}
        size="small"
        fullWidth
        error={error}
        helperText={helperText}
        slotProps={{ formHelperText: { sx: { ml: 0 } } }}
        onChange={(event) => onChange(event.target.value)}
      />
    </Stack>
  );
}
